import styled from "@emotion/styled";
import { formatColumnsAsStyles } from "../../particle";
var Container = /*#__PURE__*/ styled("div", {
    target: "eyqdobf0"
})(function(param) {
    var rules = param.rules;
    var ref;
    return (ref = rules.columns) === null || ref === void 0 ? void 0 : ref.map(formatColumnsAsStyles);
}, ";display:flex;columns:12;flex-direction:column;:not(:last-child){margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[70];
}, ";}", function(param) {
    var theme = param.theme;
    return theme.mq("sm");
}, "{:not(:last-child){margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.spacing[0];
}, ";}}");
var ColumnContainer = /*#__PURE__*/ styled("div", {
    target: "eyqdobf1"
})("display:flex;flex-direction:column;");
var TextContainer = /*#__PURE__*/ styled("div", {
    target: "eyqdobf2"
})("display:grid;grid-template-columns:repeat(12,minmax(0,1fr));");
export { ColumnContainer, Container, TextContainer };
